import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import SuccessScreen from 'creative-ui/oktaComponents/SuccessScreen';
import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import { useTranslation } from 'react-i18next';

import mfaActiveSvg from '@/assets/mfa-active.svg';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { getLoginRedirectUrl } from '@/utils/helpers/environment';

import { useMfaEnrollResultManager } from './hooks/useMfaEnrollResultManager';

// Main MFA Enroll Result Screen
function MfaEnrollResultScreen() {
  const { t } = useTranslation('mfaEnrollResult');
  const locale = useTransactionLocale();

  const { screen } = useMfaEnrollResultManager();

  const title = screen?.texts?.title || t('header.title');
  const description = screen?.texts?.description || t('header.description');
  const buttonText = t('button.goToClientArea');

  document.title = t('pageTitle');

  const handleGoToClientArea = () => {
    window.location.href = getLoginRedirectUrl(locale);
  };

  return (
    <BaseWrapper>
      <SuccessScreen
        title={title}
        image={mfaActiveSvg}
        text={description}
        isTextBeforeImage={false}>
        <CtaContainer stack>
          <Cta type="primary" onClick={handleGoToClientArea}>
            {buttonText}
          </Cta>
        </CtaContainer>
      </SuccessScreen>
    </BaseWrapper>
  );
}

export default MfaEnrollResultScreen;
